import { mainUrlRequest } from "../constants/constants";
import axios from "axios";


export default class PostService {
	static async getUserInfo() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getCurrentUser",
			},
			withCredentials: true,
		});
	}

	static async getClinics() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getItems",
				object: "clinics"
			},
		});
	}

	static async getWorkerSites() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getWorkerSites",
				object: "getWorkerSite"
			},
		});
	}

	static async getServices() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getItems",
				object: "services"
			},
		});
	}

	static async getRecordsByPeriod(clinicId, period) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getRecordsByPeriod",
				clinicId,
				period,
			},
		});
	}

	static async searchRecords(query, clinicId) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "searchRecords",
				clinicId,
				query,
			},
		});
	}

	static async getUserNotifications(clinicId, userId) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getUserNotifications",
				clinicId,
				userId,
			},
			withCredentials: true,
		});
	}

	static async getUserUnreadNotificationsCount(clinicId, userId) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getTotalUnreadNotifications",
				clinicId,
				userId,
			},
			withCredentials: true,
		});
	}

	static async markNotificationAsViewed(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "markNotificationAsViewed",
				id,
			},
		});
	}

	static async addRecord(data) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "addRecord",
				data
			},
		});
	}

	static async updateRecord(id, data) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "updateRecord",
				id,
				data
			},
		});
	}

	static async getRecordById(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "get",
				object: "records",
				id,
			},
		});
	}

	static async getSpecialistById(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "get",
                object: "getWoprkers",
				id,
			},
		});
	}

	static async authUser(login, password) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "auth",
				login,
				password,
			},
		});
	}

	static async logout() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "logout",
			},
		});
	}

	static async getSettingsByClinic(clinicId) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getSettingsByClinic",
				clinicId,
			},
		});
	}

	static async addSetting(clinicId, data) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "addSetting",
				clinicId,
				data
			},
		});
	}

	static async updateSetting(id, data) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "updateSettings",
				id,
				data
			},
		});
	}

	static async deleteSetting(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "deleteSetting",
				id,
			},
		});
	}

	static async getTimeSlots(date, clinicId, serviceId) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getTimeSlots",
				date,
				clinicId,
				serviceId,
			},
		});
	}
	static async getWorkers() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getWorkers",
			},
		});
	}
	
	static async getMonthSchedule(month) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getMonthSchedule",
				month,
			},
		});
	}
	
	static async getWorkersList() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getItems",
				object: "workersList",
			},
		});
	}
	
    static async getSlotItem(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "get",
                object: "workersList",
				id
			},
		});
	}

    static async getClinicById(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "get",
                object: "clinics",
				id
			},
		});
	}

    static async getPositions() {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getWorkerPositions",
			},
		});
	}

	static async addScheduleList(month) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "addScheduleList",
				month
			},
		});
	}

	static async fillList(id) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "fillList",
				id
			},
		});
	}

	static async getCurrentSchedule(month) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getCurrentSchedule",
				month
			},
		});
	}

	static async getListItems(ids) {
		return await axios.get(mainUrlRequest, {
			params: {
				action: "getListItems",
				ids
			},
		});
	}

    static async getAnyPlainMonthLists(month) {
		return await axios.get(mainUrlRequest, {
			params: {
                action: "getAnyPlainMonthLists",
				month
			},
		});
	}

    static async deleteSlot(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "delete",
                object: "workersList",
                id
            },
        });
    }

    static async updateWorkersList(id, data) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "update",
                object: "workersList",
                id,
                data
            },
        });
    }

    static async confirmScheduleList(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "confirmScheduleList",
                id,
            },
        });
    }

    static async editSlotItem(data) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "editSlotItem",
                data,
            },
        });
    }

    static async editSpecialistPreferences(data) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "editSpecialistPreferences",
                data,
            },
        });
    }

    static async editSalonsPositions(id, data) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "editSalonsPositions",
                id,
                data,
            },
        });
    }

    static async getTotalWorkerTime(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "getTotalWorkerTime",
                id,
            },
        });
    }
    
	static async sortSpeciaslist(ids) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "sortSpeciaslist",
                ids,
            },
        });
    }
	
	static async sortSpeciaslist(ids) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "sortSpeciaslist",
                ids,
            },
        });
    }
	
	static async getWorkerById(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "get",
				object: "workers",
                id,
            },
        });
    }
	
	static async clearMonthLists(month) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "clearMonthLists",
				month
            },
        });
    }
	
	static async getUnderfilledSpots(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "getUnderfilledSpots",
				id
            },
        });
    }
	
	static async getListWorkerAbsenceData(id) {
        return await axios.get(mainUrlRequest, {
            params: {
                action: "getListWorkerAbsenceData",
				id
            },
        });
    }
}
